
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Chess Tournament </h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm fide-chess2021 section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
            <h2> Fide Chess <span>Competition 2021</span></h2>
        </div>
        <div class="gall-ery">
            <div class="row">
                <div class="col-md-8">
                    <div class="widget_title inner-title gall-sys shadow-text-sm shadow-text-sm">
                        <h4>Fide Chess Competition 2021</h4>
                    </div>
                </div>
                <div class="col-md-4 text-end">
                    <a href="fidechess-gallery" target="_blank" class="cmn-button"><span>
                            View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                    </a>
                </div>
            </div>
            <div class="lightBox--gallery">
                <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/fide_chess_1.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/fide_chess_1.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/fide_chess_1.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/fide_chess_2.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/fide_chess_2.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/fide_chess_2.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/fide_chess_3.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/fide_chess_3.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/fide_chess_3.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/fide_chess_4.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/fide_chess_4.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/fide_chess_4.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/fide_chess_5.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/fide_chess_5.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/fide_chess_5.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/fide_chess_7.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/fide_chess_7.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/fide_chess_7.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/fide_chess_8.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/fide_chess_8.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/fide_chess_8.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/fide_chess_9.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/fide_chess_9.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/fide_chess_9.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/fide_chess_10.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/fide_chess_10.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/fide_chess_10.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/fide_chess_11.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/fide_chess_11.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/fide_chess_11.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/fide_chess_12.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/fide_chess_12.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/fide_chess_12.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/fide_chess_13.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/fide_chess_13.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/fide_chess_13.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/fide_chess_14.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/fide_chess_14.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/fide_chess_14.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/fide_chess_15.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/fide_chess_15.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/fide_chess_15.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/fide_chess_16.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/fide_chess_16.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/fide_chess_16.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/fide_chess_17.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/fide_chess_17.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/fide_chess_17.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/fide_chess_18.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/fide_chess_18.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/fide_chess_18.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/fide_chess_19.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/fide_chess_19.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/fide_chess_19.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                            </div>
                        </a>
                    </li>


                </ul>
            </div>
        </div>
        <div class="gall-ery shadow-soft">
            <div class="row">
                <div class="col-md-8">
                    <div class="widget_title inner-title gall-sys shadow-text-sm shadow-text-sm">
                        <h4>MEDIA COVERAGE</h4>
                    </div>
                </div>
                <div class="col-md-4 text-end">
                    <a href="media#media_fidechess" class="cmn-button"><span>
                            View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                    </a>
                </div>
            </div>
            <div class="row  row-cols-1 row-cols-lg-4 ">
                <div class="col">
                    <a href="https://drive.google.com/file/d/1KJROgskveq1GgeklVdq0-kfNy4IJpK-K/view?usp=sharing"
                        target="_blank">
                        <div class="category-icon-title shadow-inset">

                            <div class="category-title">
                                <span class="flaticon-pdf"></span>
                                <h4> FIDE Press Coverage 2021 </h4>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</section>
